import {
  Button,
  Input,
  Select,
  Form,
  notification,
  PageHeader,
  Col,
  Row,
  InputNumber,
} from "antd";
import { useEffect, useState } from "react";
import { Prompt, useHistory } from "react-router-dom";
import "../../Tools/customStyles.css";
import { useAuth } from "../../context/auth";
import { listPriceCalculateMethod, listPriceMethod } from "../../utils/formatter";
import IconPrice from "../../static/icon/IconPrice";
import { DatePicker } from "antd";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import { TimePicker } from "antd";

const PriceSetting = ({ match: { params: { id } } }) => {
  const history = useHistory();
  const { accessToken } = useAuth();

  const [form] = Form.useForm();
  const method = Form.useWatch('method', form);
  const calculateMethod = Form.useWatch('calculateMethod', form);
  const bahtPerHour = Form.useWatch('bahtPerHour', form);

  useEffect(() => {
    if (method === 'HOUR') form.setFieldsValue({ bahtPerKw: 0 });
    if (method === 'KW') form.setFieldsValue({ bahtPerHour: 0, calculateMethod: 'BAHT_HRS' });
  }, [form, method]);

  const [change, setChange] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (id === 'new') return;

    async function getPrice() {
      const url = new URL('/api/price/' + id, window.location);

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { price } = await res.json();
        if (!price.overrides) price.overrides = [];
        if (!price.overrideWeekdays) price.overrideWeekdays = [];

        for (const override of price.overrides) {
          override.validFrom = moment(override.validFrom);
          override.validTo = moment(override.validTo);
        }
        for (const overrideWeekday of price.overrideWeekdays) {
          overrideWeekday.validTimeFrom = moment(overrideWeekday.validTimeFrom);
          overrideWeekday.validTimeTo = moment(overrideWeekday.validTimeTo);
        }
        form.setFieldsValue(price);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    setChange(false);
    getPrice();
  }, [accessToken, form, id]);

  const save = async (values) => {
    setDisabled(true);
    setChange(false);

    const url = new URL(id === 'new' ? '/api/price' : '/api/price/' + id, window.location);

    const res = await fetch(url, {
      method: id === 'new' ? 'POST' : 'PATCH',
      headers: {
        'X-ACCESS-TOKEN': accessToken,
        'content-type': 'application/json',
      },
      body: JSON.stringify(values),
    });
    if (res.ok) {
      notification["success"]({
        message: "Successfully saved data.",
      });
      history.push({
        pathname: "/price",
        searchValue: history.location.searchValue,
        pageValue: history.location.pageValue,
      });
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }

    setDisabled(false);
    setChange(true);
  };

  return (
    <>
      <div className="flex justify-between items-center mt-2">
        <PageHeader
          style={{ padding: 0, width: "100%" }}
          title={
            <span className="flex items-center mt-2">
              <IconPrice /> &nbsp;&nbsp;Price Setting
            </span>
          }
        />
      </div>
      <div className="content">
        <div className="search">
          <Form
            form={form}
            onFinish={save}
            onFieldsChange={() => setChange(true)}
            className="search_inline row m-auto w-3/4 py-6"
          >
            <Row gutter={40} style={{ marginTop: 30 }}>
              <Col sm={24} md={24} lg={12}>
                <Form.Item
                  label="Price ID"
                  name="id"
                  colon={false}
                  className="mt-2"
                >
                  <Input
                    placeholder="Auto generate"
                    disabled={true}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={40} style={{ marginTop: 15 }}>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Description (EN)"
                  name="descEn"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Description (EN) is required.",
                    },
                    {
                      whitespace: true,
                      message: "Description (EN) is not whitespace",
                    },
                  ]}
                  className="mt-2"
                >
                  <Input
                    placeholder="Description (EN)"
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Description (TH)"
                  name="descTh"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Description (TH) is required.",
                    },
                    {
                      whitespace: true,
                      message: "Description (TH) is not whitespace",
                    },
                  ]}
                  className="mt-2"
                >
                  <Input
                    placeholder="Description (TH)"
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Method"
                  name="method"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Method is required.",
                    },
                  ]}
                  className="mt-2"
                >
                  <Select
                    placeholder="Select Method"
                    showSearch
                    options={listPriceMethod.map(type => ({
                      value: type.name,
                      label: type.value,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Calculate Method"
                  name="calculateMethod"
                  colon={false}
                  rules={[
                    {
                      required: method !== 'KW',
                      message: "Calculate Method is required.",
                    },
                  ]}
                  className="mt-2"
                >
                  <Select
                    placeholder="Select Calculate Method"
                    showSearch
                    options={listPriceCalculateMethod.map(type => ({
                      value: type.name,
                      label: type.value,
                    }))}
                    disabled={method === 'KW'}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Baht/kWh"
                  name="bahtPerKwh"
                  colon={false}
                  rules={[
                    {
                      required: method !== 'HOUR',
                      message: "Baht/kWh is required.",
                    },
                  ]}
                  className="mt-2"
                  initialValue={0}
                >
                  <InputNumber
                    formatter={(value) => {
                      var parts = value.toString().split(".");
                      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                      return parts.join(".");
                    }}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                    maxLength={10}
                    step="0.01"
                    className="w-full"
                    placeholder="0"
                    disabled={method === 'HOUR'}
                    addonAfter={
                      <span className="text-gray-600">
                        Baht/kWh
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={12} lg={6}>
                <Form.Item
                  label="Baht/hr"
                  name="bahtPerHour"
                  colon={false}
                  rules={[
                    {
                      required: method !== 'KW',
                      message: "Baht/hr is required.",
                    },
                  ]}
                  className="mt-2"
                  initialValue={0}
                >
                  <InputNumber
                    formatter={(value) => {
                      var parts = value.toString().split(".");
                      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                      return parts.join(".");
                    }}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                    maxLength={10}
                    className="w-full"
                    placeholder="0"
                    disabled={method === 'KW'}
                    addonAfter={
                      <span className="text-gray-600">
                        Baht/hr
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={12} lg={6}>
                <Form.Item className="mt-2">
                  {calculateMethod === "BAHT_MIN" ? (
                    <div style={{ fontSize: 14, color: "#BDBDBD" }}>
                      ≈ {(bahtPerHour / 60).toFixed(3)} Baht/min
                    </div>
                  ) : null}
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Extracharger fee (Baht/min)"
                  name="penaltyBahtPerMin"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Extracharger fee (Baht/min) is required.",
                    },
                  ]}
                  className="mt-2"
                  initialValue={0}
                >
                  <InputNumber
                    formatter={(value) => {
                      var parts = value.toString().split(".");
                      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                      return parts.join(".");
                    }}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                    maxLength={10}
                    className="w-full"
                    placeholder="0"
                    allowClear
                    addonAfter={
                      <span className="text-gray-600">
                        Baht/min
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <div className="flex items-center -mx-2.5 mb-2">
              <div className="flex-1 border-b border-gray-300" />
              <span className="px-2.5 pb-1 font-black">
                DC penalty after Full
              </span>
              <div className="flex-1 border-b border-gray-300" />
            </div>

            <Row gutter={40} style={{ marginTop: 30 }}>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Penalty fee (Baht/min)"
                  name="penaltyDCFullBahtPerMin"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Penalty fee (Baht/min) is required.",
                    },
                  ]}
                  className="mt-2"
                  initialValue={0}
                >
                  <InputNumber
                    formatter={(value) => {
                      var parts = value.toString().split(".");
                      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                      return parts.join(".");
                    }}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                    maxLength={10}
                    className="w-full"
                    placeholder="0"
                    allowClear
                    addonAfter={
                      <span className="text-gray-600">
                        Baht/min
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Penalty delay (min)"
                  name="penaltyDCFullDelayMin"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Penalty delay (min) is required.",
                    },
                  ]}
                  className="mt-2"
                  initialValue={0}
                >
                  <InputNumber
                    maxLength={10}
                    className="w-full"
                    placeholder="0"
                    allowClear
                    addonAfter={
                      <span className="text-gray-600">
                        min
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <div className="flex items-center -mx-2.5 mb-2">
              <div className="flex-1 border-b border-gray-300" />
              <span className="px-2.5 pb-1 font-black">
                Override Weekday
              </span>
              <div className="flex-1 border-b border-gray-300" />
            </div>

            <Form.List
              name="overrideWeekdays"
            >
              {(fields, { add, remove }) => (
                <div className="w-full">
                  {fields.map(({ name }) => (
                    <div key={name} className="flex gap-2">
                      <Form.Item
                        name={[name, "dayOfWeek"]}
                        rules={[
                          {
                            required: true,
                            message: "Day is required.",
                          },
                        ]}
                        className="w-32"
                      >
                        <Select
                          placeholder="Day"
                          options={[
                            { value: 1, label: 'Sunday' },
                            { value: 2, label: 'Monday' },
                            { value: 3, label: 'Tuesday' },
                            { value: 4, label: 'Wednesday' },
                            { value: 5, label: 'Thurday' },
                            { value: 6, label: 'Friday' },
                            { value: 7, label: 'Saturday' },
                          ]}
                        />
                      </Form.Item>
                      <Form.Item
                        name={[name, "validTimeFrom"]}
                        rules={[
                          {
                            required: true,
                            message: "From is required.",
                          },
                        ]}
                        className="w-32"
                      >
                        <TimePicker
                          placeholder="From"
                          showTime
                          format="HH:mm"
                          className="w-full"
                        />
                      </Form.Item>
                      <Form.Item
                        name={[name, "validTimeTo"]}
                        rules={[
                          {
                            required: true,
                            message: "To is required.",
                          },
                        ]}
                        className="w-32"
                      >
                        <TimePicker
                          placeholder="To"
                          showTime
                          format="HH:mm"
                          className="w-full"
                        />
                      </Form.Item>
                      <Form.Item
                        label="Baht/kWh"
                        name={[name, "bahtPerKwh"]}
                        colon={false}
                        rules={[
                          {
                            required: method !== 'HOUR',
                            message: "Baht/kWh is required.",
                          },
                        ]}
                        initialValue={0}
                      >
                        <InputNumber
                          formatter={(value) => {
                            var parts = value.toString().split(".");
                            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            return parts.join(".");
                          }}
                          parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                          maxLength={10}
                          step="0.01"
                          className="w-full"
                          placeholder="0"
                          disabled={method === 'HOUR'}
                          addonAfter={
                            <span className="text-gray-600">
                              Baht/kWh
                            </span>
                          }
                        />
                      </Form.Item>
                      <Form.Item
                        label="Baht/hr"
                        name={[name, "bahtPerHour"]}
                        colon={false}
                        rules={[
                          {
                            required: method !== 'KW',
                            message: "Baht/hr is required.",
                          },
                        ]}
                        initialValue={0}
                      >
                        <InputNumber
                          formatter={(value) => {
                            var parts = value.toString().split(".");
                            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            return parts.join(".");
                          }}
                          parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                          maxLength={10}
                          className="w-full"
                          placeholder="0"
                          disabled={method === 'KW'}
                          addonAfter={
                            <span className="text-gray-600">
                              Baht/hr
                            </span>
                          }
                        />
                      </Form.Item>
                      <Button
                        onClick={() => remove(name)}
                        icon={<CloseOutlined />}
                      />
                    </div>
                  ))}
                  <Button
                    type="primary"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    className="w-full"
                  />
                </div>
              )}
            </Form.List>

            <div className="flex items-center -mx-2.5 mb-2">
              <div className="flex-1 border-b border-gray-300" />
              <span className="px-2.5 pb-1 font-black">
                Override
              </span>
              <div className="flex-1 border-b border-gray-300" />
            </div>

            <Form.List
              name="overrides"
            >
              {(fields, { add, remove }) => (
                <div className="w-full">
                  {fields.map(({ name }) => (
                    <div key={name} className="flex gap-2">
                      <Form.Item
                        name={[name, "validFrom"]}
                        rules={[
                          {
                            required: true,
                            message: "From is required.",
                          },
                        ]}
                        className="w-48"
                      >
                        <DatePicker
                          placeholder="From"
                          showTime
                          format="YYYY-MM-DD HH:mm"
                          className="w-full"
                        />
                      </Form.Item>
                      <Form.Item
                        name={[name, "validTo"]}
                        rules={[
                          {
                            required: true,
                            message: "To is required.",
                          },
                        ]}
                        className="w-48"
                      >
                        <DatePicker
                          placeholder="To"
                          showTime
                          format="YYYY-MM-DD HH:mm"
                          className="w-full"
                        />
                      </Form.Item>
                      <Form.Item
                        label="Baht/kWh"
                        name={[name, "bahtPerKwh"]}
                        colon={false}
                        rules={[
                          {
                            required: method !== 'HOUR',
                            message: "Baht/kWh is required.",
                          },
                        ]}
                        initialValue={0}
                      >
                        <InputNumber
                          formatter={(value) => {
                            var parts = value.toString().split(".");
                            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            return parts.join(".");
                          }}
                          parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                          maxLength={10}
                          step="0.01"
                          className="w-full"
                          placeholder="0"
                          disabled={method === 'HOUR'}
                          addonAfter={
                            <span className="text-gray-600">
                              Baht/kWh
                            </span>
                          }
                        />
                      </Form.Item>
                      <Form.Item
                        label="Baht/hr"
                        name={[name, "bahtPerHour"]}
                        colon={false}
                        rules={[
                          {
                            required: method !== 'KW',
                            message: "Baht/hr is required.",
                          },
                        ]}
                        initialValue={0}
                      >
                        <InputNumber
                          formatter={(value) => {
                            var parts = value.toString().split(".");
                            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            return parts.join(".");
                          }}
                          parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                          maxLength={10}
                          className="w-full"
                          placeholder="0"
                          disabled={method === 'KW'}
                          addonAfter={
                            <span className="text-gray-600">
                              Baht/hr
                            </span>
                          }
                        />
                      </Form.Item>
                      <Button
                        onClick={() => remove(name)}
                        icon={<CloseOutlined />}
                      />
                    </div>
                  ))}
                  <Button
                    type="primary"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    className="w-full"
                  />
                </div>
              )}
            </Form.List>

            <div className="m-auto pt-6 flex justify-center space-x-4">
              <Form.Item colon={false}>
                <Button
                  className="w-36"
                  type="primary"
                  ghost
                  shape="round"
                  htmlType="button"
                  onClick={() => {
                    history.push({
                      pathname: "/price",
                      searchValue: history.location.searchValue,
                      pageValue: history.location.pageValue,
                    });
                  }}
                >
                  Cancel
                </Button>
              </Form.Item>
              <Form.Item colon={false}>
                <Button
                  className="w-36"
                  key="save"
                  type="primary"
                  shape="round"
                  htmlType="submit"
                  disabled={disabled}
                >
                  Save
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
      <Prompt when={change} message="Changes will not be saved. Do you want to proceed ?" />
    </>
  );
};
export default PriceSetting;
